import type { IEmployeeTalkState } from './IEmployeeTalkState';
import type IEmployeeTalkTemplate from './IEmployeeTalkTemplate';
import type { ETemplateCategory } from './IEmployeeTalkTemplate';
import type IEntity from './IEntity';

export enum EEmployeeTalkStatus {
    PLANNED = 'PLANNED',
    STARTED = 'STARTED',
    WAITING_FOR_APPROVAL = 'WAITING_FOR_APPROVAL',
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED',
    POSTPONED = 'POSTPONED',
}

export default interface IEmployeeTalk extends IEntity {
    id: number;
    employeeId: number;
    meetingPartnerId: number;
    templateId: number;
    templateVersion: string;
    templateData: IEmployeeTalkTemplate; // Snapshot of template at creation time
    templateCategory?: ETemplateCategory; // Category from template (ONBOARDING, JAHRESGESPRAECH, etc.)
    createdById: number;
    scheduledDate: string | undefined;
    actualDate?: string;
    durationMinutes?: number; // Umbenannt von duration zu durationMinutes
    loc?: string; // Umbenannt von location zu loc
    talkState: IEmployeeTalkState; // Umbenannt von state zu talkState
    suggestionsId?: string;
    status2: EEmployeeTalkStatus; // Umbenannt von status zu status2
    followUpDate?: string;
    employeeConfirmed: boolean;
    partnerConfirmed: boolean;
    employeeConfirmedAt?: string;
    partnerConfirmedAt?: string;
}
